export default __webpack_public_path__ + "static/media/hamburger-mail.b2681d68.svg";